// extracted by mini-css-extract-plugin
export var dateLabel = "_3i-0";
export var dateLabelError = "_3i-1";
export var fullWidth = "_3i-2";
export var smaller = "_3i-3";